import Vue from 'vue'
import MessageBox from './MessageBox.vue'

const messageBox = Vue.extend(MessageBox)

MessageBox.install = function (options, type) {
  
  if (options === undefined || options === null) {
    options = {
      content: ''
    }
  } else if (typeof options === 'string' || typeof options === 'number') {
    options = {
      content: options
    }
    if (type != undefined && options != null) {
      options.type = type;
    }
  }

  let instance = new messageBox({
    data: options
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    instance.visible = true
  })
}

export default MessageBox


// WEBPACK FOOTER //
// ./src/components/MessageBox/messageBox.js